<template>
    <b-card header-class="bar-color2 header-font">
        <template v-slot:header>
            {{ fieldsToShow.date.value}}<span v-html="'&nbsp;'"></span>
            {{ description.surgery_type | choice(surgeryFields.description_options.children.surgery_type) }} /
            {{ description.description }}
            <i
                :id="index + '-state'"
                :class="currentSurgery.state"
                class="fas fa-square ml-2"
                style="font-size: 1.2rem;"
                v-b-tooltip.hover
            />
            <b-tooltip :target="index + '-state'" triggers="hover">
                {{ $t('patient.' + currentSurgery.state) }}.
                <strong>
                    <b-link @click="$emit('gotolegend')" class="text-white">{{ $t('surgery.statehelp') }}</b-link>
                </strong>
            </b-tooltip>
        </template>

        <div class="row">
            <div class="col-12 col-md-4 mb-3 ">
                <display-field :field="{'label': $t('surgery.operation')}">
                    <span class="form-value">{{ currentSurgery.date | date({showDay: false}) }}</span>
                </display-field>
                <display-field :field="{'label': $t('datefield.hour')}">
                    <span class="form-value">{{ currentSurgery.date | time }}</span>
                </display-field>
                <display-field
                    :field="finalEvaluationFields.admission_days"
                    :value="currentSurgery.final_evaluation.admission_days"
                    value-class="form-value"
                />
            </div>

            <div class="col-12 col-md-4 mb-3 ">
                <label class="form-label mb-1">{{ $t('surgery.basalStudy') }}</label>
                <display-field
                    :field="bloodTestFields.fviii_c"
                    :value="fviiiC"
                    value-class="form-value"
                >
                    <template v-slot:help-text>
                        <span class="form-value">{{ fviiiUnit }}</span>
                    </template>
                </display-field>
                <display-field
                    :field="bloodTestFields.fviii_cr"
                    :value="fviiiCr"
                    value-class="form-value"
                >
                    <template v-slot:help-text>
                        <span class="form-value">{{ fviiiUnit }}</span>
                    </template>
                </display-field>
            </div>

            <div class="col-12 col-md-4 mb-3 ">
                <display-field
                    :field="finalEvaluationFields.total_novoeight"
                    :value="currentSurgery.final_evaluation.total_novoeight"
                    :label="$t('surgery.totalNovoeight')"
                    value-class="form-value"
                    class="d-inline-flex align-items-end"
                >
                    <template v-slot:after-value>
                        <div><img src="@/assets/icons/novoeight_icon.svg" style="height: 1.8rem" /></div>
                    </template>
                </display-field>
                <display-choice-field
                    :field="surgeryFields.clinic_response"
                    :value="currentSurgery.clinic_response"
                    value-class="form-value"
                />
            </div>
        </div>

        <b-row>
            <b-col cols="12">
                <hemocir-button
                    :title="$t('surgery.seeDetail')"
                    font-awesome-icon="fa-angle-right"
                    variant="outline-primary"
                    right-icon
                    @click="$emit('editsurgery', currentSurgery.id)"
                />
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import ShowFieldsMixin from "@/components/mixins/ShowFieldsMixin";
import DisplayField from "@/components/DisplayField";
import DisplayChoiceField from "@/components/DisplayChoiceField";
import {isNull} from "@/utils/formatting";

export default {
    name: "ListSurgeryElement",
    components: {DisplayChoiceField, DisplayField},
    mixins: [ShowFieldsMixin],
    props: {
        index: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            cols: 6
        };
    },
    computed: {
        ...mapState(['patient', 'surgeryFields', 'descriptionFields', 'finalEvaluationFields', 'bloodTestFields',]),
        ...mapGetters(['surgery']),
        description() {
            return this.patient.surgeries[this.index].description;
        },
        fieldsToShow() {
            const fields = [
                'diagnosis',
                // 'description',
                'reason',
                'date',
                'anesthesia_type',
                'weight',
                'hospitalization_date',
                'clinic_response',
                'basal_date',
                'basal_inhibitor_actual',
                'is_basal_sample_frozen',
            ];
            return this.showFieldsData(fields, this.patient.surgeries[this.index], this.surgeryFields);
        },
        cardFields() {
            const returned = {};
            for (let key in this.fieldsToShow) {
                if (key !== 'type' && key !== 'date') {
                    returned[key] = this.fieldsToShow[key];
                }
            }
            return returned;
        },
        currentSurgery() {
            return this.surgery(this.index);
        },
        fviiiC() {
            if (isNull(this.currentSurgery.basal_blood_test)) {
                return '-';
            }
            return this.currentSurgery.basal_blood_test.fviii_c;
        },
        fviiiCr() {
            if (isNull(this.currentSurgery.basal_blood_test)) {
                return '-';
            }
            return this.currentSurgery.basal_blood_test.fviii_cr;
        },
        fviiiUnit() {
            if (isNull(this.currentSurgery.basal_blood_test)) {
                return '';
            }
            return this.currentSurgery.basal_blood_test.fviii_unit;
        },
    },
};
</script>

<style lang="scss" scoped>
.header-font {
    font-weight: 600 !important;
}
</style>